<template>
  <VRow v-if="selectedProvider" class="mt-3 d-flex">
    <div class="flex-grow-1">
      <VBtn
        id="enterprise-login-redirect"
        :label="`Login with ${selectedProvider.toUpperCase()}`"
        @click="loginWithSelectedProvider()"
        color="secondaryButtons"
        class="mt-4"
        elevation="0"
        block
        data-cy="login-enterprise-redirect-button"
      >
        <VIcon icon="mdi-domain" class="mr-2" />
        Login with {{ selectedProvider.toUpperCase() }}
      </VBtn>
    </div>

    <VBtn
      tile
      icon
      class="mt-4 ml-2"
      elevation="0"
      @click="removeSelectedProvider()"
      data-cy="remove-enterprise-provider-button"
    >
      <VIcon icon="mdi-close" />
    </VBtn>
  </VRow>

  <VRow v-if="!showForm && !selectedProvider" class="mt-3">
    <VBtn
      id="enterprise-login"
      label="Enterprise login"
      @click="showForm = true"
      color="secondaryButtons"
      class="mt-4"
      elevation="0"
      block
    >
      <VIcon icon="mdi-domain" class="mr-2" />
      Enterprise login
    </VBtn>
  </VRow>

  <VRow v-if="showForm && !selectedProvider" class="mt-3">
    <VForm
      aria-label="TubeWay enterprise login"
      ref="form"
      v-on:submit.prevent="submitEnterpriseForm"
      data-cy="login-enterprise-form"
      class="w-100 d-flex"
    >
      <VTextField
        v-model="providerName"
        v-bind:rules="providerNameRules"
        v-bind:error-messages="providerNameErrors"
        @update:model-value="providerNameErrors = []"
        placeholder="Login provider name"
        prepend-inner-icon="mdi-domain"
        density="comfortable"
        variant="solo-filled"
        hide-details="auto"
        flat
        block
        required
        class="mt-4"
        append-inner-icon="mdi-arrow-right"
        @click:append-inner="submitEnterpriseForm"
        data-cy="Enterprise-login"
      >
      </VTextField>

      <VBtn tile icon class="mt-4 ml-2" elevation="0" @click="resetForm()">
        <VIcon icon="mdi-close" />
      </VBtn>
    </VForm>
  </VRow>
</template>

<script>
import { useAuthStore } from '@/stores/AuthStore'

export default {
  name: 'EnterpriseLoginButton',
  data() {
    return {
      showForm: false,

      providerName: '',
      providerNameErrors: [],
      providerNameRules: [
        v => !!v || 'Login provider name is required',
        v => (v && v.length <= 50) || 'Login provider name must be less than 50 characters',
      ],

      selectedProvider: window.localStorage.getItem('enterpriseProvider') || null,
    };
  },
  methods: {
    resetForm() {
      this.providerName = '';
      this.providerNameErrors = [];
      this.showForm = false;
    },
    submitEnterpriseForm() {
      this.providerNameErrors = [];

      const isValid = this.$refs.form.validate();
      if (isValid) {
        const provider = this.providerName.trim().toLowerCase();
        const availableProviders = ['vnb'];

        if (!availableProviders.includes(provider)) {
          this.providerNameErrors.push('Invalid login provider name');
          return;
        }

        const signinOptions = {
          provider: {
            custom: this.providerName,
          }
        };

        const authStore = useAuthStore();
        authStore.signInWithProvider(signinOptions);
        window.localStorage.setItem('enterpriseProvider', provider);
      }
    },
    loginWithSelectedProvider() {
      const provider = this.selectedProvider;

      const signinOptions = {
        provider: {
          custom: provider,
        }
      };

      const authStore = useAuthStore();
      authStore.signInWithProvider(signinOptions);
    },
    removeSelectedProvider() {
      window.localStorage.removeItem('enterpriseProvider');
      this.selectedProvider = null;
    },
  },
  computed: {
  }
}
</script>

<style>
</style>
